export const initialGenInfo = {
    name: "",
    mobile_no: "",
    date_of_birth: "",
    user_handle: "",
    gender: '',
    user_bio: "",
    about: "",
    facebook_url: "",
    x_url: "",
    insta_url: "",
    youtube_url: "",
    website_url: "",
}

export const initialGenInfoErr = {
    name: "",
    mobile_no: "",
    date_of_birth: "",
    user_handle: "",
    gender: '',
    user_bio: "",
    about: "",
    facebook_url: "",
    x_url: "",
    insta_url: "",
    youtube_url: "",
    website_url: "",
}